import React from "react";
import styles from "@/components/sidebar/styles/sidebar-item-soon.module.scss";

type SidebarItemSoonProps = {
  title: string;
};

const SidebarItemSoon = ({ title }: SidebarItemSoonProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.item}>{title}</div>
      <div className={styles.soon_wrapper}>Soon</div>
    </div>
  );
};

export default SidebarItemSoon;
